import React, { useContext, useEffect, useRef, useState } from 'react';

import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import NotoSansKannada from "../../Fonts/NotoSansKannada.ttf";
import { Document, Page, Text, View, StyleSheet, PDFViewer, Image } from '@react-pdf/renderer';
import { Font } from '@react-pdf/renderer';
import LatoItalicFont from "../../Fonts/Baloo2-VariableFont_wght.ttf";
import Logo from "../../imgs/dairylogo.png";
import { UilEditAlt, UilTrash } from '@iconscout/react-unicons'
import { lightGreen } from '@mui/material/colors';
import Globalcontext from '../../Context/Globalcontext';
import Cowsmall from "../../imgs/cowsmall.gif";
import Grass from "../../imgs/grass.png";
import { LanRounded } from '@mui/icons-material';
import { useTranslation } from "react-i18next";

// Register the font using the imported variable
Font.register({
    family: 'Lato-Italic',
    src: LatoItalicFont,
});

Font.register({
    family: "Kannada",
    src: NotoSansKannada,
});

const Billprinta4 = (props) => {
    const { t, i18n } = useTranslation();
    const [currentPage, setCurrentPage] = useState(0);
    const [customerData, setCustomerData] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [loadedPages, setLoadedPages] = useState(1);
    let bothornotmain = "";


    const loadMorePages = () => {
        setIsLoading(true);
        const pagesToLoad = 1; // Change this to load more pages

        setTimeout(() => {
            setLoadedPages(loadedPages + pagesToLoad);
            setIsLoading(false);
        }, 1000);
    };

    useEffect(() => {
        console.log(localStorage.getItem("customerData"));
        setTimeout(() => {

            if (JSON.parse(localStorage.getItem("customerData"))) {
                setCustomerData(JSON.parse(localStorage.getItem("customerData")));
                // Set loading to false when data is ready
                setIsLoading(false);
            }
        }, 200);
    }, []);

    const pageDataLength = parseFloat(Object.keys(customerData).length) / 2;
    const minutes = Math.floor(pageDataLength / 60);
    const seconds = pageDataLength % 60;

    return (
        <div className="billprintmain">
            <PDFViewer className='pdf'>
                <Document>
                    {Object.keys(customerData).map((kno, index) => (
                        <PageTemplate key={index} data={customerData[kno]} index={index} kno={kno} min={minutes} sec={seconds} pages={parseFloat(pageDataLength) * 2} t={t} lang={i18n.language} />
                    ))}
                </Document>
            </PDFViewer>
        </div>
    );
};

function PageTemplate({ data, index, kno, min, sec, pages, t, lang }) {
    const fontBase = lang === "kn" ? "Kannada" : "Lato-Italic";
    const [kapat, setKapat] = useState({});

    const [isGenerating, setIsGenerating] = useState(true);

    const generatePageContent = async () => {
        // Simulate page generation
        await new Promise(resolve => setTimeout(resolve, 1000)); // Adjust the duration as per your page generation time
        setIsGenerating(false); // Set isGenerating to false when the page is ready
    };

    useEffect(() => {
        generatePageContent();
    }, []);


    const getDatesInRange = (date1, date2) => {
        const dates = [];
        const currentDate = new Date(date1);

        while (currentDate <= new Date(date2)) {
            dates.push(currentDate.toISOString().split('T')[0]);
            currentDate.setDate(currentDate.getDate() + 1);
        }
        return dates;
    };

    const getTableDataWithZeros = (tableData, date1, date2, type, time) => {
        if (!Array.isArray(tableData)) {
            return Array.from({ length: getDatesInRange(date1, date2).length }, (_, index) => ({
                sr: '',
                date: getDatesInRange(date1, date2)[index],
                time: time,
                kno: '',
                type: type,
                liter: '0',
                fat: '0',
                snf: '0',
                rate: '0',
                amt: '0.00',
                date1: date1,
                date2: date2,
                kendra: '',
            }));
        }

        const dateRange = getDatesInRange(date1, date2);
        const tableWithData = [];

        dateRange.forEach(date => {
            const matchingEntry = tableData.find(
                entry => entry.date === date && entry.type === type && entry.time === time
            );

            if (matchingEntry) {
                tableWithData.push(matchingEntry);
            } else {
                // Create a record with zero values
                tableWithData.push({
                    sr: '',
                    date: date,
                    time: time,
                    kno: '',
                    type: type,
                    liter: '0',
                    fat: '0',
                    snf: '0',
                    rate: '0',
                    amt: '0.00',
                    date1: date1,
                    date2: date2,
                    kendra: '',
                });
            }
        });

        return tableWithData;
    };


    const styles = StyleSheet.create({
        page: {
            paddingTop: 10,
            flexDirection: 'row',
            backgroundColor: '#FFFFFF',
            justifyContent: 'center', // Center horizontally
            marginLeft: 14, // Increase the left margin
            marginRight: 13

        },
        pageWithMargin: {
            backgroundColor: "lightblue"
        },
        header: {
            position: 'absolute',
            top: 0, // Adjust this value to change the vertical position
            left: 0,
            right: 0,
            textAlign: 'center',
        },
        loading: {
            display: 'flex',
            flexDirection: 'column',
            width: '100vw',
            height: '100vh',
            justifyContent: 'center',
            alignItems: 'center'
        },
        tableContainer: {
            display: 'flex',
            flexDirection: 'column',
            width: '100vw',
            justifyContent: 'space-between',
        },
        table: {
            display: 'table',
            width: 'auto', // Adjust as needed to fit four tables in a row
            margin: 5,
            marginLeft: -1,
        },
        tableone: {
            marginTop: 5,
            marginRight: 5,
            borderWidth: 0.5,
        },
        tabletotal: {
            border: '0.5px solid #000',
            fontSize: 10,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '23mm', // Set the width of the individual cell
            backgroundColor: 'lightgray',
            marginTop: 7


        },
        tableCelloneold: {
            border: '0.5px solid lightgray',
            padding: 0.5,
            fontSize: 8,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: 3,
            flex: 1, // Remove width and use flex to distribute space equally
        },

        tableCellonebig: {
            border: '0.5px solid lightgray',
            fontSize: 9.5,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '85mm', // Set the width of the individual cell
            fontWeight: 'bold'
        },
        tableCellonebig2: {
            border: '0.5px solid #000',
            fontSize: 9.5,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: '10px',
            width: '85mm', // Set the width of the individual cell
            fontWeight: 'bold'
        },
        tableCellonebigdata: {
            border: '0.5px solid lightgray',
            fontSize: 10,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: '3mm',
            width: '85mm', // Set the width of the individual cell
            fontWeight: 'bold'
        },
        tableRowone: {
            flexDirection: 'row',
            width: '65%',
            height: 17,
            textAlign: 'right',
            marginLeft: -5,
        },
        tableRowonebig: {
            flexDirection: 'row',
            width: '80%',
            height: 17,
            textAlign: 'right',
            marginLeft: -5,
        },
        tableHeaderone: {
            flexDirection: 'row',
            width: '65%',
            height: 17,
            textAlign: 'right',
            border: '0.5px solid #000',
            marginLeft: -5,
            backgroundColor: 'lightgray'
        },
        tableHeaderonebig: {
            flexDirection: 'row',
            width: '80%',
            height: 17,
            textAlign: 'right',
            border: '0.5px solid #000',
            marginLeft: -5,
            backgroundColor: 'lightgray'
        },
        allbill: {
            flexDirection: 'row',
            width: '65%',
            textAlign: 'right',
            height: 17,
            marginLeft: -5,
            backgroundColor: 'lightgray',
            marginTop: 5
        },
        allbillbig: {
            border: '0.5px solid lightgray',
            flexDirection: 'row',
            width: '80%',
            textAlign: 'right',
            height: 17,
            marginLeft: -5,
            backgroundColor: 'lightgray',
            marginTop: 5
        },
        tableRow: {
            flexDirection: 'row',
            height: 17,
            marginLeft: 3,
        },
        tableRow2: {
            flexDirection: 'row',
            height: 17,
            marginLeft: 3,
            marginTop: 5,
            backgroundColor: 'lightgray'
        },
        tableRow3: {
            flexDirection: 'row',
            height: 17,
            backgroundColor: 'lightgray'
        },

        grandTotalContainer: {
            marginTop: 10,
            backgroundColor: '#f0f0f0',  // a light gray
            paddingVertical: 4,
            borderRadius: 4,
            alignItems: 'center',
        },
        grandTotalText: {
            fontFamily: fontBase,
            textAlign: 'center',
            paddingHorizontal: 4,
        },

        line: {
            flexDirection: 'row',
            backgroundColor: 'lightgray',
            height: 1,
            marginTop: -2,
            width: '95vw',
        },
        linenormal: {
            flexDirection: 'row',
            backgroundColor: 'lightgray',
            height: 1,
            marginTop: 3,
            marginBottom: 3,
            width: '97vw',
        },

        lineshort: {
            flexDirection: 'row',
            backgroundColor: 'lightgray',
            height: 1,
            marginTop: 1,
            width: '7vw',
        },

        tableHeader: {
            border: '0.5px solid #000',
            padding: 0.5,
            fontSize: 8,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '5mm', // Set the width of the individual cell
            backgroundColor: 'lightgray',
        },
        tableHeadersm: {
            border: '0.5px solid #000',
            fontSize: 8,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '11mm', // Set the width of the individual cell
            backgroundColor: 'lightgray',
        },
        tableHeadersmbig: {
            border: '0.5px solid #000',
            fontSize: 10,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '14mm', // Set the width of the individual cell
            backgroundColor: 'lightgray',
        },
        tableHeadersmbig2: {
            border: '0.5px solid #000',
            fontSize: 10,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '13mm', // Set the width of the individual cell
            backgroundColor: 'lightgray',
        },
        tableHeadersmbig3: {
            border: '0.5px solid #000',
            fontSize: 10,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: 2,
            width: '19mm', // Set the width of the individual cell
            backgroundColor: 'lightgray',
        },
        tableHeadersmextra: {
            border: '0.5px solid #000',
            fontSize: 10,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: 2,
            width: '23mm', // Set the width of the individual cell
            backgroundColor: 'lightgray',
        },
        tableHeadermed: {
            border: '0.5px solid #000',
            padding: 0.5,
            fontSize: 8,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '13mm', // Set the width of the individual cell
            backgroundColor: 'lightgray',
        },
        tableHeadermedbig: {
            border: '0.5px solid #000',
            padding: 0.5,
            fontSize: 9,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '13mm', // Set the width of the individual cell
            backgroundColor: 'lightgray',
        },
        tableHeadermed2: {
            border: '0.5px solid #000',
            padding: 0.5,
            fontSize: 8,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '19mm', // Set the width of the individual cell
            backgroundColor: 'lightgray',
        },
        tableHeadermed2big: {
            border: '0.5px solid #000',
            padding: 0.5,
            fontSize: 10,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '19mm', // Set the width of the individual cell
            backgroundColor: 'lightgray',
        },
        tableCell: {
            border: '0.5px solid lightgray',
            fontSize: 8,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '1mm', // Set the width of the individual cell
        },
        tableCellbig: {
            border: '0.5px solid lightgray',
            fontSize: 10,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '1mm', // Set the width of the individual cell
        },
        tableCellsm: {
            border: '0.5px solid lightgray',
            fontSize: 8,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '11mm', // Set the width of the individual cell
        },
        tableCellsmamt: {
            border: '0.5px solid lightgray',
            fontSize: 8,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: 2,
            width: '18mm', // Set the width of the individual cell

        },
        tableCellsmbig: {
            border: '0.5px solid lightgray',
            fontSize: 10,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '14mm', // Set the width of the individual cell

        },
        tableCellmed: {
            border: '0.5px solid lightgray',
            fontSize: 8,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: '1mm',
            width: '13mm', // Set the width of the individual cell
        },
        tableCellmedbig: {
            border: '0.5px solid lightgray',
            fontSize: 10,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: '1mm',
            width: '13mm', // Set the width of the individual cell
        },
        tableCellmed2: {
            border: '0.5px solid lightgray',
            fontSize: 8,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: '1mm',
            width: '19mm', // Set the width of the individual cell
        },
        column1Labelcenter2: {
            fontFamily: fontBase,
            fontSize: 10,
            fontWeight: 'bold',
            alignSelf: 'center',
            textAlign: 'center', // Align labels to the left
        },
        tableCellmed2big: {
            border: '0.5px solid lightgray',
            fontSize: 10,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: '1mm',
            width: '19mm', // Set the width of the individual cell
        },
        latoText: {
            fontFamily: fontBase,
            fontSize: 15,
            marginBottom: 5,
            textAlign: 'center',
            width: '100%',
            fontWeight: 'bold',
            marginLeft: -15,
            marginTop: 1,
        },
        headtextsmall: {
            fontFamily: fontBase,
            fontSize: 10,
            fontWeight: 'bold',
        },
        headtextsmalll: {
            fontFamily: fontBase,
            fontSize: 9,
            fontWeight: 'bold',
            marginRight: 5
        },
        headtextsmalltype: {
            fontFamily: fontBase,
            fontSize: 10,
            fontWeight: 'bold',
        },
        headtextsmall2: {
            fontFamily: fontBase,
            fontSize: 14,
            marginLeft: 20,
            marginTop: -5,
            fontWeight: 'bold',
        },
        headtextsmall3: {
            fontFamily: fontBase,
            fontSize: 14,
            color: 'rgb(156, 44, 24)',
            fontWeight: 'bold',
            alignSelf: 'center'
        },
        headtextsmall4: {
            fontFamily: fontBase,
            fontSize: 10,
            color: 'rgb(156, 44, 24)',
            fontWeight: 'bold',
            alignSelf: 'center'
        },
        headtextsmallleft1: {
            fontFamily: fontBase,
            fontSize: 9,
            marginLeft: -70,
            marginTop: -5,
            fontWeight: 'bold',
        },
        headtextsmallleft2: {
            fontFamily: fontBase,
            fontSize: 9,
            marginLeft: 0,
            marginTop: -5,
            fontWeight: 'bold',
        },
        headtextsmallleft3: {
            fontFamily: fontBase,
            fontSize: 9,
            marginLeft: 0,
            marginTop: -5,
            fontWeight: 'bold',
        },
        headtextsmallleft4: {
            fontFamily: fontBase,
            fontSize: 9,
            marginRight: -50,
            marginTop: -5,
            fontWeight: 'bold',
        },

        headtextsmallleft1big: {
            fontFamily: fontBase,
            fontSize: 11,
            marginLeft: -70,
            marginTop: -5,
            fontWeight: 'bold',
        },
        headtextsmallleft2big: {
            fontFamily: fontBase,
            fontSize: 11,
            marginLeft: 0,
            marginTop: -5,
            fontWeight: 'bold',
        },

        row: {
            display: 'flex',
            flexDirection: 'row',
            width: '95vw',
        },
        row1: {
            display: 'flex',
            flexDirection: 'row',
            width: '95vw',
            justifyContent: 'space-between',
            alignItems: 'center',
        },

        row2: {
            display: 'flex',
            flexDirection: 'row',
            width: '95vw',
            alignItems: 'center',
            justifyContent: 'center',
            alignContent: 'center'
        },
        row2both: {
            display: 'flex',
            flexDirection: 'row',
            width: '95vw',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingLeft: 130,
            paddingRight: 130,
            backgroundColor: 'lightgray',
        },
        row2bothwhite: {
            display: 'flex',
            flexDirection: 'row',
            width: '95vw',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingLeft: 130,
            paddingRight: 130,

        },
        row2single: {
            display: 'flex',
            flexDirection: 'row',
            width: '95vw',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingLeft: '250px',
            backgroundColor: 'lightgray',
        },
        column1: {
            display: 'flex',
            flexDirection: 'column',
            width: '15%',
            justifyContent: 'start',
            alignItems: 'flex-start', // Align text to the left
            paddingLeft: 5,
            paddingRight: 5,
            marginLeft: 10,
            border: '0.5px solid black',
        },
        column1noborder: {
            display: 'flex',
            flexDirection: 'column',
            width: '23%',
            justifyContent: 'start',
            alignItems: 'flex-start', // Align text to the left
            paddingLeft: 5,
            paddingRight: 5,
            marginLeft: 10,
        },
        column2: {
            display: 'flex',
            flexDirection: 'column',
            width: '15%',
            justifyContent: 'start',
            alignItems: 'flex-start', // Align text to the left
            paddingLeft: 5,
            paddingRight: 5,
            marginLeft: 5,
            border: '0.5px solid black',

        },
        column2noborder: {
            display: 'flex',
            flexDirection: 'column',
            width: '15%',
            justifyContent: 'start',
            alignItems: 'flex-start', // Align text to the left
            paddingLeft: 5,
            paddingRight: 5,
            marginLeft: 5
        },
        column3: {
            display: 'flex',
            flexDirection: 'column',
            width: '15%',
            paddingLeft: 3,
            paddingRight: 3,
            justifyContent: 'start',
            alignItems: 'flex-start', // Align text to the left
            border: '0.5px solid black',
            marginLeft: 7,
        },
        column3noborder: {
            display: 'flex',
            flexDirection: 'column',
            width: '15%',
            paddingLeft: 3,
            paddingRight: 3,
            justifyContent: 'start',
            alignItems: 'flex-start', // Align text to the left
            marginLeft: 7,
        },

        column1Row: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
        },
        column1Rowratib: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            marginTop: -5,
        },
        column1Rowratib2: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            marginTop: -5,
            marginBottom: 3
        },
        simplerow: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            width: '20%',
        },
        simplecol: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            marginTop: -1
        },
        column1Rowgray: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            padding: 2,
            marginTop: 1,
            marginBottom: 5,
            border: '0.5px solid black',
            backgroundColor: 'lightgray'
        },
        column1Label: {
            fontFamily: fontBase,
            fontSize: 9,
            fontWeight: 'bold',
            textAlign: 'left', // Align labels to the left
        },
        column1Value: {
            fontFamily: fontBase,
            fontSize: 9,
            fontWeight: 'bold',
            textAlign: 'right', // Align values to the right
        },
        pageBreak: {
            pageBreakBefore: 'always',
        },
        totalsRow: {
            flexDirection: 'row',
            borderTop: '1px solid #000',
            paddingTop: 5,
            paddingLeft: 2,
        },
        totalsCell: {
            border: '0.5px solid lightgray',
            padding: 0.5,
            flex: 1,
            fontSize: 8,
            width: 2,
            textAlign: 'center',
        },
        imagerow: {
            display: 'flex',
            flexDirection: 'row',
            width: '95vw',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: 4
        },
        image: {
            width: 45, // Adjust the width as needed
            height: "auto", // Maintain aspect ratio
            marginLeft: -5,
            marginTop: 5

        },
        imgtext: {
            fontFamily: fontBase,
            fontSize: 9,
            fontWeight: 'bold',
            textAlign: 'center', // Align labels to the left
        },
        tableCellgreen: {
            border: '0.5px solid lightgray',
            padding: 0.5,
            flex: 1,
            fontSize: 12,
            fontWeight: 'bold',
            fontFamily: fontBase,
            color: 'green',
            width: 2,
            fontWeight: 'bold',
            textAlign: 'center',
        },
        tableCellred: {
            border: '0.5px solid lightgray',
            padding: 0.5,
            flex: 1,
            fontSize: 12,
            fontWeight: 'bold',
            fontFamily: fontBase,
            color: 'red',
            width: 3,
            fontWeight: 'bold',
            textAlign: 'center',
        },
        loadingSpinner: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            fontSize: 16,
            fontWeight: 'bold',
            color: 'gray',
        },

        tableSectionRow: {
            flexDirection: 'row',
            marginBottom: 1,
        },
        tableSectionHorizontal: {
            fontFamily: fontBase,
            fontSize: 9,
            marginHorizontal: 5,
        },
        tableSectionVerti: {
            fontFamily: fontBase,
            flexDirection: 'column',
            fontSize: 9,
            marginHorizontal: 5,
        },

        tableHeaderone: {
            backgroundColor: '#eee',
        },
        tableRowone: {
            borderBottomWidth: 1,
            borderColor: '#ccc',
        },
        tableCellone: {
            width: 40,                 // or whatever your column width is
            textAlign: 'right',
            padding: 0.7,
            fontWeight: 'bold',
            paddingRight: 5,
            fontSize: 9,
            fontFamily: fontBase,
        },
        tableCellonerakkam: {
            width: 65,                 // or whatever your column width is
            textAlign: 'right',
            padding: 0.7,
            color: 'black',
            fontWeight: 'bold',
            paddingRight: 5,
            fontSize: 9,
            fontFamily: fontBase,

        },
        tableCellextra: {
            width: 40,                 // or whatever your column width is
            textAlign: 'right',
            padding: 0.7,
            fontWeight: 'bold',
            paddingRight: 5,
            fontSize: 9,
            fontFamily: fontBase,
        },

        totalRow: {
            marginTop: 10,
            alignItems: 'center',
        },
        totalText: {
            fontWeight: 'bold',
            fontSize: 11,
        },

    });

    const knoData = data;
    const groupByTypeAndTime = {};

    let tlitermhmor = 0;
    let tlitermhevn = 0;
    let tlitergaymor = 0;
    let tlitergayevn = 0;

    // Group data by 'type' and 'time'
    knoData.forEach(entry => {
        const key = entry.type + '-' + entry.time;
        tlitermhmor = entry.tlitermhmor;
        tlitermhevn = entry.tlitermhevn;
        tlitergaymor = entry.tlitergaymor;
        tlitergayevn = entry.tlitergayevn;
        if (!groupByTypeAndTime[key]) {
            groupByTypeAndTime[key] = [];
        }
        groupByTypeAndTime[key].push(entry);
    });

    const tableDataArrays = ['Buffalo-Morning', 'Buffalo-Evening', 'Cow-Morning', 'Cow-Evening'].map((typeTimeKey) => {
        const [type, time] = typeTimeKey.split('-');
        const entries = groupByTypeAndTime[typeTimeKey]; // You should define 'groupByTypeAndTime' based on your data structure.
        return getTableDataWithZeros(entries, knoData[0].date1, knoData[0].date2, type, time);
    });

    function formatDate(inputDate) {
        const options = { day: '2-digit', month: 'short', year: 'numeric' };
        return new Date(inputDate).toLocaleDateString('en-US', options);
    }


    const calculateSumOfAmtColumns = (tableDataArray) => {
        const sums = Array.from({ length: tableDataArray[0].length }, () => 0); // Initialize an array with zeros based on the length of the first table

        // Loop through the tables and calculate sums for each record
        tableDataArray.forEach((tableDataWithZeros) => {
            tableDataWithZeros.forEach((entry, entryIndex) => {
                sums[entryIndex] += parseFloat(entry.amt);
            });
        });
        return sums;
    };

    const sumsOfAmtColumns = calculateSumOfAmtColumns(tableDataArrays);
    //  console.log("sumsOfAmtColumns: ", sumsOfAmtColumns);
    const sumOfFifthTable = sumsOfAmtColumns.reduce((total, sum) => total + parseFloat(sum), 0).toFixed(2);
    let totalOfTotalLiter = 0;
    let totalOfTotalFat = 0;
    let tkapat = 0;
    let tyene = 0;
    let ada = 0;

    let zeroflagmh = false;
    let zeroflaggay = false;

    let zeroflagmhevn = false;
    let zeroflaggayevn = false;

    let totalLiterMh = 0;
    let totalLiterGay = 0;

    const notify = (msg) => toast(msg);
    const notifyerror = (msg) => toast.error(msg);
    const [isboth, setIsboth] = useState(false);

    useEffect(() => {
        if (zeroflagmh && zeroflaggay) {
            //   console.log("in both");
            setIsboth(true);
        }
    }, [zeroflagmh, zeroflaggay]);

    const sakalData = getTableDataWithZeros(
        groupByTypeAndTime['Buffalo-Morning'],
        knoData[0].date1,
        knoData[0].date2,
        'Buffalo',
        'Morning'
    );
    const sandhyaData = getTableDataWithZeros(
        groupByTypeAndTime['Buffalo-Evening'],
        knoData[0].date1,
        knoData[0].date2,
        'Buffalo',
        'Evening'
    );
    const dailyTotals = sakalData.map((entry, idx) => {
        const amt1 = +entry.amt || 0;
        const amt2 = +sandhyaData[idx]?.amt || 0;
        return amt1 + amt2;
    });


    const dailyTliter2 = sakalData.map((entry, idx) => {
        const liter1 = +entry.liter || 0;
        const liter2 = +sandhyaData[idx]?.liter || 0;
        return (liter1 + liter2);
    });

    const dailyTliter = dailyTliter2;
    //---


    const sakalData2 = getTableDataWithZeros(
        groupByTypeAndTime['Cow-Morning'],
        knoData[0].date1,
        knoData[0].date2,
        'Cow',
        'Morning'
    );
    const sandhyaData2 = getTableDataWithZeros(
        groupByTypeAndTime['Cow-Evening'],
        knoData[0].date1,
        knoData[0].date2,
        'Cow',
        'Evening'
    );
    const dailyTotalsgay = sakalData2.map((entry, idx) => {
        const amt1 = +entry.amt || 0;
        const amt2 = +sandhyaData2[idx]?.amt || 0;
        return amt1 + amt2;
    });


    const dailyTlitergay = sakalData2.map((entry, idx) => {
        const liter1 = +entry.liter || 0;
        const liter2 = +sandhyaData2[idx]?.liter || 0;
        return (liter1 + liter2);
    });

    tkapat = parseFloat(knoData[0].cthev !== null && !isNaN(knoData[0].cthev) ? knoData[0].cthev : 0)
        + parseFloat(knoData[0].cthevitr1 !== null && !isNaN(knoData[0].cthevitr1) ? knoData[0].cthevitr1 : 0)
        + parseFloat(knoData[0].cthevitr2 !== null && !isNaN(knoData[0].cthevitr2) ? knoData[0].cthevitr2 : 0)
        + parseFloat(knoData[0].cthevitr3 !== null && !isNaN(knoData[0].cthevitr3) ? knoData[0].cthevitr3 : 0)
        + parseFloat(knoData[0].itrkapat1 !== null && !isNaN(knoData[0].itrkapat1) ? knoData[0].itrkapat1 : 0)
        + parseFloat(knoData[0].itrkapat2 !== null && !isNaN(knoData[0].itrkapat2) ? knoData[0].itrkapat2 : 0)
        + parseFloat(knoData[0].itrkapat3 !== null && !isNaN(knoData[0].itrkapat3) ? knoData[0].itrkapat3 : 0)
        + parseFloat(knoData[0].retan !== null && !isNaN(knoData[0].retan) ? knoData[0].retan : 0)
        + parseFloat(knoData[0].medi !== null && !isNaN(knoData[0].medi) ? knoData[0].medi : 0)
        + parseFloat(knoData[0].advkapat !== null && !isNaN(knoData[0].advkapat) ? knoData[0].advkapat : 0)
        + parseFloat(knoData[0].ratibkapat !== null && !isNaN(knoData[0].ratibkapat) ? knoData[0].ratibkapat : 0)
        + parseFloat(knoData[0].khadyakapat !== null && !isNaN(knoData[0].khadyakapat) ? knoData[0].khadyakapat : 0)
        + parseFloat(knoData[0].karjhpta !== null && !isNaN(knoData[0].karjhpta) ? knoData[0].karjhpta : 0)
        + parseFloat(knoData[0].karjintr !== null && !isNaN(knoData[0].karjintr) ? knoData[0].karjintr : 0)
        + parseFloat(knoData[0].sanghkapat !== null && !isNaN(knoData[0].sanghkapat) ? knoData[0].sanghkapat : 0)
        + parseFloat(knoData[0].cbhishi !== null && !isNaN(knoData[0].cbhishi) ? knoData[0].cbhishi : 0)
        + parseFloat(knoData[0].ikapatliter !== null && !isNaN(knoData[0].ikapatliter) ? parseFloat(knoData[0].ikapatliter) : 0) + parseFloat(knoData[0].ikapatbill !== null && !isNaN(knoData[0].ikapatbill) ? parseFloat(knoData[0].ikapatbill).toFixed(2) : 0) //+ parseFloat(knoData[0].vah !== null && !isNaN(knoData[0].vah) ? (parseFloat(knoData[0].vah)) : 0)

    {
        localStorage.getItem("billtype") === "oldbill" ?
            tyene = parseFloat(knoData[0].newadv !== null && !isNaN(knoData[0].newadv) ? knoData[0].newadv : 0) + parseFloat(knoData[0].newkhadya !== null && !isNaN(knoData[0].newkhadya) ? knoData[0].newkhadya : 0)
            :
            tyene = '0';
    }

    ada = parseFloat(parseFloat(sumOfFifthTable) - parseFloat(tkapat) + parseFloat(knoData[0].vah !== null && !isNaN(knoData[0].vah) ? (parseFloat(knoData[0].vah)) : 0) + parseFloat(knoData[0].comm !== null && !isNaN(knoData[0].comm) ? (parseFloat(knoData[0].comm)) : 0)).toFixed(2);


    const renderTable = (
        tableDataWithZeros,
        tableIndex,
        totalLiter,
        avgfat,
        avgsnf,
        totalAmt,
        typeTimeKey,
        dateflag,     // 1 when this table should show date column
        bothornot,
        avgrate
    ) => {
        return (
            <View key={typeTimeKey} style={styles.table}>
                {/* Table Header */}
                <View style={styles.tableRow}>
                    {(tableIndex === 0 || tableIndex === 2) && (
                        <Text
                            style={[
                                bothornot === "both" ? styles.tableHeadersmbig : styles.tableHeadersmbig,
                                { width: bothornot === "both" ? 38 : 38 }
                            ]}
                        >
                            {t("billprint3.table.date")}
                        </Text>
                    )}

                    <Text style={bothornot === "both" ? styles.tableHeadersmbig : styles.tableHeadersmbig}>
                        {t("billprint3.table.liter")}
                    </Text>

                    <Text style={bothornot === "both" ? styles.tableHeadersmbig : styles.tableHeadersmbig}>
                        {t("billprint3.table.fat")}
                    </Text>

                    <Text style={bothornot === "both" ? styles.tableHeadersmbig : styles.tableHeadersmbig}>
                        {t("billprint3.table.snf")}
                    </Text>

                    <Text style={bothornot === "both" ? styles.tableHeadersmbig2 : styles.tableHeadersmbig2}>
                        {t("billprint3.table.rate")}
                    </Text>

                    <Text style={bothornot === "both" ? styles.tableHeadersmbig3 : styles.tableHeadersmbig3}>
                        {t("billprint3.table.amount")}
                    </Text>
                </View>

                {/* Table Data */}
                {tableDataWithZeros.map((entry, entryIndex) => (
                    <View key={entryIndex} style={styles.tableRow}>
                        {(tableIndex === 0 || tableIndex === 2) && (
                            <Text
                                style={[
                                    bothornot === "both" ? styles.tableHeadersmbig : styles.tableHeadersmbig,
                                    { width: bothornot === "both" ? 38 : 38 }
                                ]}
                            >
                                {entry.date.substr(5).split('-').reverse().join('/')}
                            </Text>
                        )}
                        {entry.liter === '0' ? (
                            <>
                                <Text style={bothornot === "both" ? styles.tableCellsmbig : styles.tableCellsmbig} />
                                <Text style={bothornot === "both" ? styles.tableCellsmbig : styles.tableCellsmbig} />
                                <Text style={bothornot === "both" ? styles.tableCellsmbig : styles.tableCellsmbig} />
                                <Text style={bothornot === "both" ? styles.tableCellmedbig : styles.tableCellmedbig} />
                                <Text style={bothornot === "both" ? styles.tableCellmed2big : styles.tableCellmed2big} />
                            </>
                        ) : (
                            <>
                                <Text style={bothornot === "both" ? styles.tableCellsmbig : styles.tableCellsmbig}>
                                    {entry.liter}
                                </Text>
                                <Text style={bothornot === "both" ? styles.tableCellsmbig : styles.tableCellsmbig}>
                                    {entry.fat}
                                </Text>
                                <Text style={bothornot === "both" ? styles.tableCellsmbig : styles.tableCellsmbig}>
                                    {entry.snf}
                                </Text>
                                <Text style={bothornot === "both" ? styles.tableCellmedbig : styles.tableCellmedbig}>
                                    {parseFloat(entry.rate).toFixed(2)}
                                </Text>
                                <Text style={bothornot === "both" ? styles.tableCellmed2big : styles.tableCellmed2big}>
                                    {parseFloat(entry.amt).toFixed(2)}
                                </Text>
                            </>
                        )}
                    </View>
                ))}

                {/* Totals Row */}
                <View style={styles.tableRow2}>
                    {(tableIndex === 0 || tableIndex === 2) && (
                        <Text
                            style={[
                                bothornot === "both" ? styles.tableHeadersmbig : styles.tableHeadersmbig,
                                { width: bothornot === "both" ? 39 : 39 }
                            ]}
                        >
                            {t("billprint4.totalSectionTitle")}
                        </Text>
                    )}

                    <Text style={bothornot === "both" ? styles.tableHeadersmbig : styles.tableHeadersmbig}>
                        {totalLiter.toFixed(1)}
                    </Text>

                    {localStorage.getItem("avg") === "On" ? (
                        <>
                            <Text style={bothornot === "both" ? styles.tableHeadersmbig : styles.tableHeadersmbig}>
                                {avgfat ? avgfat.toFixed(1) : "0.0"}
                            </Text>
                            <Text style={bothornot === "both" ? styles.tableHeadersmbig : styles.tableHeadersmbig}>
                                {avgsnf ? avgsnf.toFixed(1) : "0.0"}
                            </Text>
                            <Text style={bothornot === "both" ? styles.tableHeadersmbig2 : styles.tableHeadersmbig2}>
                                {avgrate ? avgrate.toFixed(2) : "0.0"}
                            </Text>
                        </>
                    ) : (
                        <>
                            <Text style={bothornot === "both" ? styles.tableHeadersmbig : styles.tableHeadersmbig}>-</Text>
                            <Text style={bothornot === "both" ? styles.tableHeadersmbig : styles.tableHeadersmbig}>-</Text>
                            <Text style={bothornot === "both" ? styles.tableHeadersmbig2 : styles.tableHeadersmbig2}>-</Text>
                        </>
                    )}

                    <Text
                        style={bothornot === "both" ? styles.tableHeadersmbig3 : styles.tableHeadersmbig3}
                    >
                        {totalAmt.toFixed(2)}
                    </Text>
                </View>
            </View>
        );
    };


    let dateflag = "";
    let bothornot = "";
    let milktype = "";

    if (tlitermhmor != null && tlitermhevn != null && tlitergaymor != null && tlitergayevn != null) {
        dateflag = 0;
        bothornot = "both";

    }

    if (tlitermhmor != null && tlitermhevn != null && tlitergaymor == null && tlitergayevn == null) {
        dateflag = 0;
        bothornot = "not";
        milktype = "Buffalo";

    }

    if (tlitermhmor == null && tlitermhevn != null && tlitergaymor == null && tlitergayevn == null) {
        dateflag = 0;
        bothornot = "not";
        milktype = "Buffalo";

    }

    if (tlitermhmor == null && tlitermhevn != null && tlitergaymor != null && tlitergayevn == null) {
        dateflag = 0;
        bothornot = "both";

    }

    if (tlitermhmor == null && tlitermhevn != null && tlitergaymor != null && tlitergayevn != null) {
        dateflag = 0;
        bothornot = "both";

    }

    if (tlitermhmor == null && tlitermhevn == null && tlitergaymor != null && tlitergayevn != null) {
        dateflag = 2;
        bothornot = "not";
        milktype = "Cow";

    }

    if (tlitermhmor != null && tlitermhevn != null && tlitergaymor != null && tlitergayevn == null) {
        dateflag = 0;
        bothornot = "both";

    }

    if (tlitermhmor != null && tlitermhevn != null && tlitergaymor == null && tlitergayevn != null) {
        dateflag = 0;
        bothornot = "both";
    }


    if (tlitermhmor != null && tlitermhevn == null && tlitergaymor == null && tlitergayevn == null) {
        dateflag = 0;
        bothornot = "not";
        milktype = "Buffalo";
    }

    // Remaining combinations

    if (tlitermhmor == null && tlitermhevn == null && tlitergaymor == null && tlitergayevn == null) {
        //

    }

    if (tlitermhmor != null && tlitermhevn == null && tlitergaymor != null && tlitergayevn == null) {
        dateflag = 0;
        bothornot = "both";
    }

    if (tlitermhmor != null && tlitermhevn == null && tlitergaymor == null && tlitergayevn != null) {
        dateflag = 0;
        bothornot = "both";

    }

    if (tlitermhmor == null && tlitermhevn == null && tlitergaymor != null && tlitergayevn == null) {
        dateflag = 2;
        bothornot = "not";
        milktype = "Cow";

    }

    if (tlitermhmor == null && tlitermhevn != null && tlitergaymor == null && tlitergayevn != null) {
        dateflag = 0;
        bothornot = "both";

    }

    if (tlitermhmor != null && tlitermhevn == null && tlitergaymor != null && tlitergayevn != null) {
        dateflag = 0;
        bothornot = "both";

    }

    if (tlitermhmor == null && tlitermhevn == null && tlitergaymor == null && tlitergayevn != null) {
        dateflag = 2;
        bothornot = "not";
        milktype = "Cow";
    }

    if (tlitermhmor == null && tlitermhevn == null && tlitergaymor != null && tlitergayevn != null) {
        dateflag = 2;
        bothornot = "not";
        milktype = "Cow";
    }



    return (
        <>
            <Page
                key={index}
                size={localStorage.getItem("dur") === "10" ? "A4" : "A4"}
                orientation={localStorage.getItem("dur") === "10" ? "portrait" : "portrait"}
                style={styles.page}
            >
                {isGenerating ? (
                    <View style={styles.loading}>
                        <Text style={styles.headtextsmall3}>
                            {t("billprint4.loading.generating", { min, sec })}
                        </Text>
                        <Text style={styles.headtextsmall4}>
                            {t("billprint4.loading.totalPages", { pages })}
                        </Text>
                    </View>

                ) : (

                    <View>
                        <View style={styles.row2}>
                            <Text style={styles.headtextsmall2}>{knoData[0].kendra + "," + localStorage.getItem("city")}</Text>
                        </View>


                        {/* Inside your PDF component’s render/return */}
                        <View style={styles.tableContainer}>
                            {bothornot === "both" ? (
                                <>
                                    <View style={styles.row1}>
                                        <Text style={styles.headtextsmall}>
                                            {`${t("billprint4.account")} : ${kno}`}
                                        </Text>
                                    </View>

                                    <View style={styles.row1}>
                                        <Text style={styles.headtextsmall}>
                                            {`${t("billprint4.header.accountHolderName")} : ${knoData[0].cname}`}
                                        </Text>

                                        <Text style={styles.headtextsmall}>
                                            {`${t("billprint4.period")} : ${formatDate(knoData[0].date1)}   ${t("common.to")}   ${formatDate(knoData[0].date2)}`}
                                        </Text>
                                    </View>

                                    <View style={styles.linenormal} />

                                    <View style={styles.row2bothwhite}>
                                        <Text style={styles.headtextsmall}>{t("common.morning")}</Text>
                                        <Text style={styles.headtextsmall}>{t("common.evening")}</Text>
                                    </View>

                                    <View style={styles.linenormal} />

                                    <Text style={styles.headtextsmall}>{t("common.buffalo")}</Text>

                                    <View style={styles.lineshort} />
                                    <View style={styles.lineshort} />


                                    {/* ----- Buffalo: Morning + Evening + रक्कम ----- */}
                                    <View style={styles.tableSectionRow}>
                                        {['Buffalo-Morning', 'Buffalo-Evening'].map((typeTimeKey, idx) => {
                                            const [type, time] = typeTimeKey.split('-');
                                            const entries = groupByTypeAndTime[typeTimeKey];
                                            const tableData = getTableDataWithZeros(entries, knoData[0].date1, knoData[0].date2, type, time);
                                            const totalLiter = tableData.reduce((s, e) => s + +e.liter, 0);
                                            const totalFat = tableData.filter(e => e.fat > 0).reduce((s, e) => s + +e.fat, 0);
                                            const avgfat = totalFat / tableData.filter(e => e.fat > 0).length;
                                            const totalSNF = tableData.filter(e => e.snf > 0).reduce((s, e) => s + +e.snf, 0);
                                            const avgsnf = totalSNF / tableData.filter(e => e.snf > 0).length;
                                            const totalRate = tableData.filter(e => e.rate > 0).reduce((s, e) => s + +e.rate, 0);
                                            const avgrate = totalRate / tableData.filter(e => e.rate > 0).length;
                                            const totalAmt = tableData.reduce((s, e) => s + +e.amt, 0);

                                            return (
                                                <View key={idx} style={styles.tableSectionHorizontal}>
                                                    {renderTable(tableData, idx, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, 1, 'both', avgrate)}
                                                </View>
                                            );
                                        })}


                                        return (
                                        <View style={styles.tableSectionRow}>
                                            {/* other two columns… */}

                                            {/* रक्कम column */}
                                            <View style={styles.tableSectionHorizontal}>
                                                {/* Main table of daily values */}
                                                <View style={styles.tableone}>
                                                    <View style={styles.tableHeaderone}>
                                                        <Text style={styles.tableHeadersmextra}>{t("billprint4.table.amount")}</Text>

                                                    </View>
                                                    {dailyTotals.map((amt, i) => (
                                                        <View key={i} style={styles.tableRowone}>
                                                            <Text style={styles.tableCellonerakkam}>{amt.toFixed(2)}</Text>
                                                        </View>
                                                    ))}
                                                </View>

                                                {/* Separate grand total table */}

                                                <View style={styles.tabletotal}>
                                                    <Text style={styles.tableCellonerakkam}>
                                                        {dailyTotals.reduce((sum, a) => sum + a, 0).toFixed(2)}
                                                    </Text>
                                                </View>
                                            </View>
                                        </View>
                                        );
                                    </View>



                                    {parseFloat(knoData[0].gaycomm) > 0 || parseFloat(knoData[0].mhcomm) > 0 ?
                                        <>
                                            {/* <View style={styles.row1}>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmalll}>{"एकूण रक्कम: "}</Text>
                                                <Text style={styles.headtextsmalll}>{dailyTotals.reduce((sum, a) => sum + a, 0).toFixed(2)}</Text>
                                            </View> */}
                                            <View style={styles.row1}>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmalll}>{t("billprint4.management")}</Text>
                                                <Text style={styles.headtextsmalll}>{parseFloat(parseFloat(knoData[0].mhcomm) * parseFloat(dailyTliter.reduce((sum, a) => sum + a, 0))).toFixed(2)}</Text>
                                            </View>
                                            {/* <View style={styles.row1}>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmalll}>{"बिल रक्कम: "}</Text>
                                                <Text style={styles.headtextsmalll}>{parseFloat(parseFloat(dailyTotals.reduce((sum, a) => sum + a, 0)) + parseFloat(parseFloat(knoData[0].mhcomm) * parseFloat(dailyTliter.reduce((sum, a) => sum + a, 0)))).toFixed(2)}</Text>
                                            </View> */}
                                        </>
                                        : ''}

                                    {/* <View style={styles.linenormal} /> */}
                                    <Text style={styles.headtextsmall}>{"Cow"}</Text>
                                    <View style={styles.lineshort} />
                                    <View style={styles.lineshort} />

                                    <View style={styles.tableSectionRow}>
                                        {['Cow-Morning', 'Cow-Evening'].map((typeTimeKey, idx) => {
                                            const [type, time] = typeTimeKey.split('-');
                                            const entries = groupByTypeAndTime[typeTimeKey];
                                            const tableData = getTableDataWithZeros(
                                                entries,
                                                knoData[0].date1,
                                                knoData[0].date2,
                                                type,
                                                time
                                            );

                                            const totalLiter = tableData.reduce((s, e) => s + +e.liter, 0);
                                            const totalFat = tableData.filter(e => e.fat > 0).reduce((s, e) => s + +e.fat, 0);
                                            const avgfat = totalFat / (tableData.filter(e => e.fat > 0).length || 1);
                                            const totalSNF = tableData.filter(e => e.snf > 0).reduce((s, e) => s + +e.snf, 0);
                                            const avgsnf = totalSNF / (tableData.filter(e => e.snf > 0).length || 1);
                                            const totalRate = tableData.filter(e => e.rate > 0).reduce((s, e) => s + +e.rate, 0);
                                            const avgrate = totalRate / (tableData.filter(e => e.rate > 0).length || 1);
                                            const totalAmt = tableData.reduce((s, e) => s + +e.amt, 0);

                                            return (
                                                <View key={idx} style={styles.tableSectionHorizontal}>
                                                    {renderTable(
                                                        tableData,
                                                        idx + 2, // index offset
                                                        totalLiter,
                                                        avgfat,
                                                        avgsnf,
                                                        totalAmt,
                                                        typeTimeKey,
                                                        1, // ✅ show date for first table only (Cow-Morning)
                                                        'both',
                                                        avgrate
                                                    )}
                                                </View>
                                            );
                                        })}

                                        return (
                                        <View style={styles.tableSectionRow}>
                                            {/* other two columns… */}

                                            {/* रक्कम column */}
                                            <View style={styles.tableSectionHorizontal}>
                                                {/* Main table of daily values */}
                                                <View style={styles.tableone}>
                                                    <View style={styles.tableHeaderone}>
                                                        <Text style={styles.tableHeadersmextra}>{t("billprint4.table.amount")}</Text>
                                                    </View>
                                                    {dailyTotalsgay.map((amt, i) => (
                                                        <View key={i} style={styles.tableRowone}>
                                                            <Text style={styles.tableCellonerakkam}>{amt.toFixed(2)}</Text>
                                                        </View>
                                                    ))}
                                                </View>

                                                {/* Separate grand total table */}

                                                <View style={styles.tabletotal}>
                                                    <Text style={styles.tableCellonerakkam}>
                                                        {dailyTotalsgay.reduce((sum, a) => sum + a, 0).toFixed(2)}
                                                    </Text>

                                                </View>

                                            </View>
                                        </View>
                                        );

                                    </View>

                                    {parseFloat(knoData[0].gaycomm) > 0 || parseFloat(knoData[0].mhcomm) > 0 ?
                                        <>
                                            {/* <View style={styles.row1}>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmalll}>{"एकूण रक्कम: "}</Text>
                                                <Text style={styles.headtextsmalll}>{dailyTotalsgay.reduce((sum, a) => sum + a, 0).toFixed(2)}</Text>
                                            </View> */}
                                            <View style={styles.row1}>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmalll}>{t("billprint4.management")}</Text>

                                                <Text style={styles.headtextsmalll}>{parseFloat(parseFloat(knoData[0].gaycomm) * parseFloat(dailyTlitergay.reduce((sum, a) => sum + a, 0))).toFixed(2)}</Text>
                                            </View>
                                            {/* <View style={styles.row1}>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmall}>{""}</Text>
                                                <Text style={styles.headtextsmalll}>{"बिल रक्कम: "}</Text>
                                                <Text style={styles.headtextsmalll}>{parseFloat(dailyTotalsgay.reduce((sum, a) => sum + a, 0) + dailyTlitergay.reduce((sum, a) => sum + a, 0)).toFixed(2)}</Text>
                                            </View> */}
                                        </>
                                        : ''}

                                </>
                            )
                                : (() => {
                                    // Precompute dailyTotals for the single type
                                    const sakalData = getTableDataWithZeros(
                                        groupByTypeAndTime[`${milktype}-Morning`] || [],
                                        knoData[0].date1,
                                        knoData[0].date2,
                                        milktype,
                                        'Morning'
                                    );
                                    const sandhyaData = getTableDataWithZeros(
                                        groupByTypeAndTime[`${milktype}-Evening`] || [],
                                        knoData[0].date1,
                                        knoData[0].date2,
                                        milktype,
                                        'Evening'
                                    );
                                    const dailyTotals = sakalData.map((entry, i) => {
                                        const amt1 = +entry.amt || 0;
                                        const amt2 = +sandhyaData[i]?.amt || 0;
                                        return amt1 + amt2;
                                    });

                                    return (
                                        <>
                                            <View style={styles.row1}>
                                                <Text style={styles.headtextsmall}>
                                                    {`${t("billprint4.account")} : xtxt ${kno}`}
                                                </Text>
                                            </View>

                                            <View style={styles.row1}>
                                                <Text style={styles.headtextsmall}>
                                                    {`${t("billprint4.accountHolderName")} : ${knoData[0].cname}`}
                                                </Text>

                                                <Text style={styles.headtextsmall}>
                                                    {`${t("billprint4.period")} : ${formatDate(knoData[0].date1)}   ${t("common.to")}   ${formatDate(knoData[0].date2)}`}
                                                </Text>
                                            </View>

                                            <View style={styles.linenormal} />

                                            <View style={styles.row2bothwhite}>
                                                <Text style={styles.headtextsmall}>{t("common.morning")}</Text>
                                                <Text style={styles.headtextsmall}>{t("common.evening")}</Text>
                                            </View>

                                            <View style={styles.linenormal} />
                                            <Text style={styles.headtextsmall}>{knoData[0].type}</Text>
                                            <View style={styles.lineshort} />
                                            <View style={styles.lineshort} />
                                            {/* Row 1: Morning, Evening, daily रक्कम */}
                                            <View style={styles.tableSectionRow}>
                                                {['Morning', 'Evening'].map((time, idx) => {
                                                    const key = `${milktype}-${time}`;
                                                    const entries = groupByTypeAndTime[key] || [];
                                                    const tableData = getTableDataWithZeros(
                                                        entries,
                                                        knoData[0].date1,
                                                        knoData[0].date2,
                                                        milktype,
                                                        time
                                                    );
                                                    const totalLiter = tableData.reduce((s, e) => s + +e.liter, 0);
                                                    const totalFat = tableData.filter(e => e.fat > 0).reduce((s, e) => s + +e.fat, 0);
                                                    const avgfat = totalFat / (tableData.filter(e => e.fat > 0).length || 1);
                                                    const totalSNF = tableData.filter(e => e.snf > 0).reduce((s, e) => s + +e.snf, 0);
                                                    const avgsnf = totalSNF / (tableData.filter(e => e.snf > 0).length || 1);
                                                    const totalRate = tableData.filter(e => e.rate > 0).reduce((s, e) => s + +e.rate, 0);
                                                    const avgrate = totalRate / (tableData.filter(e => e.rate > 0).length || 1);
                                                    const totalAmt = tableData.reduce((s, e) => s + +e.amt, 0);

                                                    return (
                                                        <View key={key} style={styles.tableSectionVerti}>
                                                            {renderTable(
                                                                tableData,
                                                                idx,
                                                                totalLiter,
                                                                avgfat,
                                                                avgsnf,
                                                                totalAmt,
                                                                key,
                                                                1,      // show दिनांक
                                                                'not',
                                                                avgrate
                                                            )}
                                                        </View>
                                                    );
                                                })}


                                                {/* Daily रक्कम column */}
                                                <View style={styles.tableSectionVerti}>
                                                    <View style={styles.tableone}>
                                                        <View style={styles.tableHeaderone}>
                                                            <Text style={styles.tableHeadersmextra}>{t("billprint4.table.amount")}</Text>
                                                        </View>
                                                        {dailyTotals.map((amt, i) => (
                                                            <View key={i} style={styles.tableRowone}>
                                                                <Text style={styles.tableCellonerakkam}>{amt.toFixed(2)}</Text>
                                                            </View>
                                                        ))}
                                                    </View>

                                                    <View style={styles.tableSectionRow}>

                                                        <View style={styles.tabletotal}>
                                                            <Text style={styles.tableCellonerakkam}>
                                                                {dailyTotals.reduce((sum, a) => sum + a, 0).toFixed(2)}
                                                            </Text>

                                                        </View>
                                                    </View>

                                                </View>

                                            </View>


                                            {parseFloat(knoData[0].gaycomm) > 0 || parseFloat(knoData[0].mhcomm) > 0 ?
                                                <>
                                                    {/* <View style={styles.row1}>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmalll}>{"एकूण रक्कम: "}</Text>
                                                        <Text style={styles.headtextsmalll}>{parseFloat(dailyTotals.reduce((sum, a) => sum + a, 0) + dailyTotalsgay.reduce((sum, a) => sum + a, 0)).toFixed(2)}</Text>
                                                    </View> */}
                                                    <View style={styles.row1}>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmalll}>{t("billprint4.management")}</Text>
                                                        <Text style={styles.headtextsmalll}>{parseFloat(parseFloat(parseFloat(knoData[0].gaycomm) * parseFloat(dailyTlitergay.reduce((sum, a) => sum + a, 0))) + parseFloat(parseFloat(knoData[0].mhcomm) * parseFloat(dailyTliter.reduce((sum, a) => sum + a, 0)))).toFixed(2)}</Text>
                                                    </View>
                                                    {/* <View style={styles.row1}>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmall}>{""}</Text>
                                                        <Text style={styles.headtextsmalll}>{"बिल रक्कम: "}</Text>
                                                        <Text style={styles.headtextsmalll}>{parseFloat(parseFloat(dailyTotals.reduce((sum, a) => sum + a, 0) + dailyTotalsgay.reduce((sum, a) => sum + a, 0)) + parseFloat(parseFloat(parseFloat(knoData[0].gaycomm) * parseFloat(dailyTlitergay.reduce((sum, a) => sum + a, 0))) + parseFloat(parseFloat(knoData[0].mhcomm) * parseFloat(dailyTliter.reduce((sum, a) => sum + a, 0))))).toFixed(2)}</Text>
                                                    </View> */}
                                                </>
                                                : ''
                                            }

                                        </>
                                    );
                                })()
                            }
                        </View>



                        {localStorage.getItem("design") === "1" ?
                            <View style={styles.row}>
                                <View style={styles.column2}>
                                    <Text style={styles.column1Labelcenter2}>{t("billprint4.deposit")}</Text>
                                </View>

                                <View style={styles.column1}>
                                    <Text style={styles.column1Labelcenter2}>{t("billprint4.advance")}</Text>
                                </View>

                                <View style={styles.column1}>
                                    <Text style={styles.column1Labelcenter2}>{t("billprint4.khady")}</Text>
                                </View>

                                <View style={styles.column1}>
                                    <Text style={styles.column1Labelcenter2}>{t("billprint4.ratib")}</Text>
                                </View>

                                <View style={styles.column3}>
                                    <Text style={styles.column1Labelcenter2}>{"-"}</Text>
                                </View>

                                <View style={styles.column3}>
                                    <Text style={styles.column1Labelcenter2}>{t("billprint4.bill")}</Text>
                                </View>
                            </View>
                            : ''
                        }


                        <View style={styles.row}>
                            {/* ठेव */}
                            <View style={localStorage.getItem("design") === "1" ? styles.column2 : styles.column2noborder}>

                                {
                                    localStorage.getItem("showthev") === "Yes" ?
                                        localStorage.getItem("billtype") === "oldbill" ?
                                            <View style={styles.column1Row}>
                                                <Text style={styles.column1Label}>{t("billprint.depositBox.prev")}</Text>
                                                <Text style={styles.column1Value}>
                                                    {knoData[0].mthev !== null && !isNaN(knoData[0].mthev) ? parseFloat(knoData[0].mthev).toFixed(2) : 0}
                                                </Text>
                                            </View>
                                            :
                                            <View style={styles.column1Row}>
                                                <Text style={styles.column1Label}>{t("billprint.depositBox.prev")}</Text>
                                                <Text style={styles.column1Value}>
                                                    {parseFloat(localStorage.getItem("bcount")) > 0
                                                        ? (knoData[0].newthev !== null && !isNaN(knoData[0].newthev) ? knoData[0].newthev : 0)
                                                        : (knoData[0].othev !== null && !isNaN(knoData[0].othev) ? knoData[0].othev : 0)}
                                                </Text>
                                            </View>
                                        : ''
                                }

                                {localStorage.getItem("billtype") === "oldbill" ?
                                    <View style={styles.column1Row}>
                                        <Text style={styles.column1Label}>{t("billprint.depositBox.deduct")}</Text>
                                        <Text style={styles.column1Value}>
                                            {knoData[0].cthev !== null && !isNaN(knoData[0].cthev) ? knoData[0].cthev : 0}
                                        </Text>
                                    </View>
                                    :
                                    <View style={styles.column1Row}>
                                        <Text style={styles.column1Label}>{t("billprint.depositBox.deduct")}</Text>
                                        <Text style={styles.column1Value}>
                                            {parseFloat(parseFloat(knoData[0].mhliter * knoData[0].mhthev) + parseFloat(knoData[0].gayliter * knoData[0].gaythev)).toFixed(2)}
                                        </Text>
                                    </View>
                                }

                                {
                                    localStorage.getItem("showthev") === "Yes" ?
                                        (localStorage.getItem("billtype") === "oldbill" ?
                                            <View style={styles.column1Row}>
                                                <Text style={styles.column1Label}>{t("billprint.depositBox.total")}</Text>
                                                <Text style={styles.column1Value}>
                                                    {((!isNaN(parseFloat(knoData[0].newthev)) ? parseFloat(knoData[0].newthev) : 0)).toFixed(2)}
                                                </Text>
                                            </View>
                                            :
                                            <View style={styles.column1Row}>
                                                <Text style={styles.column1Label}>{t("billprint.depositBox.total")}</Text>
                                                <Text style={styles.column1Value}>
                                                    {(
                                                        parseFloat(localStorage.getItem("bcount")) > 0
                                                            ? parseFloat(knoData[0].newthev !== null && !isNaN(knoData[0].newthev) ? knoData[0].newthev : 0) +
                                                            parseFloat(parseFloat(parseFloat(knoData[0].mhliter * knoData[0].mhthev) + parseFloat(knoData[0].gayliter * knoData[0].gaythev)).toFixed(2))
                                                            : parseFloat(knoData[0].othev !== null && !isNaN(knoData[0].othev) ? knoData[0].othev : 0) +
                                                            parseFloat(parseFloat(parseFloat(knoData[0].mhliter * knoData[0].mhthev) + parseFloat(knoData[0].gayliter * knoData[0].gaythev)).toFixed(2))
                                                    ).toFixed(2)}
                                                </Text>
                                            </View>)
                                        : ''
                                }

                                {
                                    (localStorage.getItem("sanghk") == "On" ?
                                        <View style={styles.column1Row}>
                                            <Text style={styles.column1Label}>{localStorage.getItem("sanghkname")} : </Text>
                                            <Text style={styles.column1Value}>{knoData[0].sanghkapat}</Text>
                                        </View>
                                        : '')
                                }
                            </View>

                            {/* एड्व्हांस  */}
                            {
                                localStorage.getItem("design") === "1" ?
                                    <>
                                        {/* ADVANCE */}
                                        <View style={styles.column1}>
                                            {localStorage.getItem("billtype") === "oldbill" ?
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint3.commonBox.prev")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {knoData[0].madv !== null && !isNaN(knoData[0].madv) ? parseFloat(knoData[0].madv).toFixed(2) : 0}
                                                    </Text>
                                                </View>
                                                :
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint3.commonBox.prev")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {parseFloat(localStorage.getItem("bcount")) > 0
                                                            ? (knoData[0].madv !== null && !isNaN(knoData[0].madv) ? knoData[0].madv : 0)
                                                            : (knoData[0].obal !== null && !isNaN(knoData[0].obal) ? knoData[0].obal : 0)}
                                                    </Text>
                                                </View>
                                            }

                                            <View style={styles.column1Row}>
                                                <Text style={styles.column1Label}>{t("billprint3.commonBox.on")}</Text>
                                                <Text style={styles.column1Value}>
                                                    {parseFloat(knoData[0].cadv !== null && !isNaN(knoData[0].cadv) ? knoData[0].cadv : 0).toFixed(2)}
                                                </Text>
                                            </View>

                                            {localStorage.getItem("billtype") === "oldbill" ?
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint3.commonBox.deduct")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {knoData[0].advkapat !== null && !isNaN(knoData[0].advkapat) ? parseFloat(knoData[0].advkapat).toFixed(2) : 0}
                                                    </Text>
                                                </View>
                                                :
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint3.commonBox.deduct")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {kapat[kno] && !isNaN(kapat[kno].cuchal) ? parseFloat(kapat[kno].cuchal).toFixed(2) : 0}
                                                    </Text>
                                                </View>
                                            }

                                            {localStorage.getItem("billtype") === "oldbill" ?
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint3.commonBox.balance")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {((parseFloat(knoData[0].newadv) || 0)).toFixed(2)}
                                                    </Text>
                                                </View>
                                                :
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint3.commonBox.balance")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {(
                                                            parseFloat(localStorage.getItem("bcount")) > 0
                                                                ? (parseFloat(knoData[0].madv !== null && !isNaN(knoData[0].madv) ? knoData[0].madv : 0) +
                                                                    parseFloat(knoData[0].cadv !== null && !isNaN(knoData[0].cadv) ? knoData[0].cadv : 0) -
                                                                    parseFloat(kapat[kno] && !isNaN(kapat[kno].cuchal) ? kapat[kno].cuchal : 0))
                                                                : (parseFloat(knoData[0].obal !== null && !isNaN(knoData[0].obal) ? knoData[0].obal : 0) +
                                                                    parseFloat(knoData[0].cadv !== null && !isNaN(knoData[0].cadv) ? knoData[0].cadv : 0) -
                                                                    parseFloat(kapat[kno] && !isNaN(kapat[kno].cuchal) ? kapat[kno].cuchal : 0))
                                                        ).toFixed(2)}
                                                    </Text>
                                                </View>
                                            }
                                        </View>

                                        {/* KHADYA */}
                                        <View style={styles.column1}>
                                            <View style={styles.column1Row}>
                                                <Text style={styles.column1Label}>{t("billprint3.commonBox.prev")}</Text>
                                                <Text style={styles.column1Value}>
                                                    {knoData[0].mkhadya !== null && !isNaN(knoData[0].mkhadya) ? parseFloat(knoData[0].mkhadya).toFixed(2) : 0}
                                                </Text>
                                            </View>

                                            <View style={styles.column1Row}>
                                                <Text style={styles.column1Label}>{t("billprint3.commonBox.on")}</Text>
                                                <Text style={styles.column1Value}>
                                                    {knoData[0].ckhadya !== null && !isNaN(knoData[0].ckhadya) ? knoData[0].ckhadya : 0}
                                                </Text>
                                            </View>

                                            {localStorage.getItem("billtype") === "oldbill" ?
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint3.commonBox.deduct")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {knoData[0].khadyakapat !== null && !isNaN(knoData[0].khadyakapat) ? parseFloat(knoData[0].khadyakapat).toFixed(2) : 0}
                                                    </Text>
                                                </View>
                                                :
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint3.commonBox.deduct")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {kapat[kno] && !isNaN(kapat[kno].ckhadya) ? parseFloat(kapat[kno].ckhadya).toFixed(2) : 0}
                                                    </Text>
                                                </View>
                                            }

                                            {localStorage.getItem("billtype") === "oldbill" ?
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint3.commonBox.balance")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {((parseFloat(knoData[0].newkhadya) || 0)).toFixed(2)}
                                                    </Text>
                                                </View>
                                                :
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint3.commonBox.balance")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {(
                                                            (parseFloat(knoData[0].mkhadya !== null && !isNaN(knoData[0].mkhadya) ? knoData[0].mkhadya : 0) +
                                                                parseFloat(knoData[0].ckhadya !== null && !isNaN(knoData[0].ckhadya) ? knoData[0].ckhadya : 0) -
                                                                parseFloat(kapat[kno] && !isNaN(kapat[kno].ckhadya) ? kapat[kno].ckhadya : 0))
                                                        ).toFixed(2)}
                                                    </Text>
                                                </View>
                                            }
                                        </View>

                                        {/* RATIB */}
                                        <View style={styles.column1}>
                                            <View style={styles.column1Row}>
                                                <Text style={styles.column1Label}>{t("billprint3.commonBox.prev")}</Text>
                                                <Text style={styles.column1Value}>
                                                    {knoData[0].mratib !== null && !isNaN(knoData[0].mratib) ? parseFloat(knoData[0].mratib).toFixed(2) : 0}
                                                </Text>
                                            </View>

                                            <View style={styles.column1Row}>
                                                <Text style={styles.column1Label}>{t("billprint3.commonBox.on")}</Text>
                                                <Text style={styles.column1Value}>
                                                    {knoData[0].cratib !== null && !isNaN(knoData[0].cratib) ? knoData[0].cratib : 0}
                                                </Text>
                                            </View>

                                            {localStorage.getItem("billtype") === "oldbill" ?
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint3.commonBox.deduct")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {knoData[0].ratibkapat !== null && !isNaN(knoData[0].ratibkapat) ? parseFloat(knoData[0].ratibkapat).toFixed(2) : 0}
                                                    </Text>
                                                </View>
                                                :
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint3.commonBox.deduct")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {kapat[kno] && !isNaN(kapat[kno].ratibkapat) ? parseFloat(kapat[kno].ratibkapat).toFixed(2) : 0}
                                                    </Text>
                                                </View>
                                            }

                                            {localStorage.getItem("billtype") === "oldbill" ?
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint3.commonBox.balance")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {((parseFloat(knoData[0].newratib) || 0)).toFixed(2)}
                                                    </Text>
                                                </View>
                                                :
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint3.commonBox.balance")}</Text>
                                                    <Text style={styles.column1Value}>{""}</Text>
                                                </View>
                                            }
                                        </View>
                                    </>
                                    :
                                    <>
                                        {/* DESIGN != 1 (SUMMARY STYLE) */}
                                        <View style={styles.column1noborder}>
                                            {localStorage.getItem("billtype") === "oldbill" ?
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint3.summaryBox.prevBalance")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {parseFloat(
                                                            parseFloat(knoData[0].madv !== null && !isNaN(knoData[0].madv) ? parseFloat(knoData[0].madv).toFixed(2) : 0) +
                                                            parseFloat(knoData[0].mkhadya !== null && !isNaN(knoData[0].mkhadya) ? knoData[0].mkhadya : 0) +
                                                            parseFloat(knoData[0].mratib !== null && !isNaN(knoData[0].mratib) ? knoData[0].mratib : 0)
                                                        ).toFixed(2)}
                                                    </Text>
                                                </View>
                                                :
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint3.summaryBox.prevBalance")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {parseFloat(localStorage.getItem("bcount")) > 0
                                                            ? parseFloat(parseFloat(knoData[0].madv !== null && !isNaN(knoData[0].madv) ? parseFloat(knoData[0].madv).toFixed(2) : 0) + parseFloat(knoData[0].mkhadya !== null && !isNaN(knoData[0].mkhadya) ? knoData[0].mkhadya : 0)).toFixed(2)
                                                            : (knoData[0].obal !== null && !isNaN(knoData[0].obal) ? knoData[0].obal : 0)}
                                                    </Text>
                                                </View>
                                            }

                                            <View style={styles.column1Row}>
                                                <Text style={styles.column1Label}>
                                                    {localStorage.getItem("billtype") === "oldbill" ? t("billprint3.summaryBox.khadyOn") : t("billprint3.summaryBox.khadyOnN")}
                                                </Text>
                                                <Text style={styles.column1Value}>{knoData[0].ckhadya !== null && !isNaN(knoData[0].ckhadya) ? knoData[0].ckhadya : 0}</Text>
                                            </View>

                                            <View style={styles.column1Row}>
                                                <Text style={styles.column1Label}>
                                                    {localStorage.getItem("billtype") === "oldbill" ? t("billprint3.summaryBox.advanceOn") : t("billprint3.summaryBox.advanceOnN")}
                                                </Text>
                                                <Text style={styles.column1Value}>{parseFloat(knoData[0].cadv !== null && !isNaN(knoData[0].cadv) ? knoData[0].cadv : 0).toFixed(2)}</Text>
                                            </View>

                                            <View style={styles.column1Row}>
                                                <Text style={styles.column1Label}>
                                                    {localStorage.getItem("billtype") === "oldbill" ? t("billprint3.summaryBox.ratibOn") : t("billprint3.summaryBox.ratibOnN")}
                                                </Text>
                                                <Text style={styles.column1Value}>{parseFloat(knoData[0].cratib !== null && !isNaN(knoData[0].cratib) ? knoData[0].cratib : 0).toFixed(2)}</Text>
                                            </View>
                                        </View>

                                        <View style={styles.column1noborder}>
                                            <View style={styles.column1Row}>
                                                <Text style={styles.column1Label}>{t("billprint3.summaryBox.totalBalance")}</Text>
                                                <Text style={styles.column1Value}>
                                                    {parseFloat(
                                                        parseFloat(
                                                            parseFloat(knoData[0].madv !== null && !isNaN(knoData[0].madv) ? parseFloat(knoData[0].madv).toFixed(2) : 0) +
                                                            parseFloat(knoData[0].mkhadya !== null && !isNaN(knoData[0].mkhadya) ? knoData[0].mkhadya : 0) +
                                                            parseFloat(knoData[0].mratib !== null && !isNaN(knoData[0].mratib) ? knoData[0].mratib : 0)
                                                        ) +
                                                        parseFloat(knoData[0].ckhadya !== null && !isNaN(knoData[0].ckhadya) ? knoData[0].ckhadya : 0) +
                                                        parseFloat(knoData[0].cadv !== null && !isNaN(knoData[0].cadv) ? knoData[0].cadv : 0) +
                                                        parseFloat(knoData[0].cratib !== null && !isNaN(knoData[0].cratib) ? knoData[0].cratib : 0)
                                                    ).toFixed(2)}
                                                </Text>
                                            </View>

                                            <View style={styles.column1Row}>
                                                <Text style={styles.column1Label}>{t("billprint3.summaryBox.directDeduct")}</Text>
                                                <Text style={styles.column1Value}>
                                                    {parseFloat(
                                                        parseFloat(knoData[0].advkapat !== null && !isNaN(knoData[0].advkapat) ? parseFloat(knoData[0].advkapat).toFixed(2) : 0) +
                                                        parseFloat(knoData[0].khadyakapat !== null && !isNaN(knoData[0].khadyakapat) ? parseFloat(knoData[0].khadyakapat).toFixed(2) : 0) +
                                                        parseFloat(knoData[0].ratibkapat !== null && !isNaN(knoData[0].ratibkapat) ? parseFloat(knoData[0].ratibkapat).toFixed(2) : 0)
                                                    ).toFixed(2)}
                                                </Text>
                                            </View>

                                            <View style={styles.column1Row}>
                                                <Text style={styles.column1Label}>{t("billprint3.summaryBox.dueBalance")}</Text>
                                                <Text style={styles.column1Value}>
                                                    {parseFloat(
                                                        parseFloat(
                                                            parseFloat(
                                                                parseFloat(knoData[0].madv !== null && !isNaN(knoData[0].madv) ? parseFloat(knoData[0].madv).toFixed(2) : 0) +
                                                                parseFloat(knoData[0].mkhadya !== null && !isNaN(knoData[0].mkhadya) ? knoData[0].mkhadya : 0) +
                                                                parseFloat(knoData[0].mratib !== null && !isNaN(knoData[0].mratib) ? knoData[0].mratib : 0)
                                                            ) +
                                                            parseFloat(knoData[0].ckhadya !== null && !isNaN(knoData[0].ckhadya) ? knoData[0].ckhadya : 0) +
                                                            parseFloat(knoData[0].cadv !== null && !isNaN(knoData[0].cadv) ? knoData[0].cadv : 0) +
                                                            parseFloat(knoData[0].cratib !== null && !isNaN(knoData[0].cratib) ? knoData[0].cratib : 0)
                                                        ) -
                                                        parseFloat(
                                                            parseFloat(knoData[0].advkapat !== null && !isNaN(knoData[0].advkapat) ? parseFloat(knoData[0].advkapat).toFixed(2) : 0) +
                                                            parseFloat(knoData[0].khadyakapat !== null && !isNaN(knoData[0].khadyakapat) ? parseFloat(knoData[0].khadyakapat).toFixed(2) : 0) +
                                                            parseFloat(knoData[0].ratibkapat !== null && !isNaN(knoData[0].ratibkapat) ? parseFloat(knoData[0].ratibkapat).toFixed(2) : 0)
                                                        )
                                                    ).toFixed(2)}
                                                </Text>
                                            </View>
                                        </View>
                                    </>
                            }


                            {/* एकूण */}
                            {/* TOTAL + OTHER (keep same styles, only replace hardcoded strings with billprint4 keys) */}
                            <View style={localStorage.getItem("design") === "1" ? styles.column3 : styles.column3noborder}>
                                <View style={styles.column1Row}>
                                    <Text style={styles.column1Label}>{t("billprint4.totalBox.liter")}</Text>
                                    <Text style={styles.column1Value}>{totalOfTotalLiter.toFixed(2)}</Text>
                                </View>

                                <View style={styles.column1Row}>
                                    <Text style={styles.column1Label}>{t("billprint4.totalBox.yene")}</Text>
                                    <Text style={styles.column1Value}>{tyene.toFixed(2)}</Text>
                                </View>

                                {localStorage.getItem("showother") === "Yes" ? (
                                    <>
                                        {parseFloat(knoData[0].ikapatliter !== null && !isNaN(knoData[0].ikapatliter) ? parseFloat(knoData[0].ikapatliter) : 0) > 0 ? (
                                            localStorage.getItem("billtype") === "oldbill" ? (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint4.totalBox.otherDeductPerLiter")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {knoData[0].ikapatliter !== null && !isNaN(knoData[0].ikapatliter) ? parseFloat(knoData[0].ikapatliter) : 0}
                                                    </Text>
                                                </View>
                                            ) : (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint4.totalBox.otherDeductPerLiterN")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {knoData[0].ikapatliter !== null && !isNaN(knoData[0].ikapatliter)
                                                            ? parseFloat(parseFloat(knoData[0].ikapatliter) * parseFloat(totalOfTotalLiter)).toFixed(2)
                                                            : 0}
                                                    </Text>
                                                </View>
                                            )
                                        ) : (
                                            ""
                                        )}

                                        {/* NOTE: you had this block twice; kept only once to avoid duplicate line */}
                                        {parseFloat(knoData[0].ikapatbill !== null && !isNaN(knoData[0].ikapatbill) ? parseFloat(knoData[0].ikapatbill) : 0) > 0 ? (
                                            <View style={styles.column1Row}>
                                                <Text style={styles.column1Label}>{localStorage.getItem("itrmainname")}</Text>
                                                <Text style={styles.column1Value}>
                                                    {knoData[0].ikapatbill !== null && !isNaN(knoData[0].ikapatbill) ? parseFloat(knoData[0].ikapatbill).toFixed(2) : 0}
                                                </Text>
                                            </View>
                                        ) : (
                                            ""
                                        )}
                                    </>
                                ) : (
                                    ""
                                )}

                                {localStorage.getItem("itrname") != "-" ? (
                                    <View style={styles.column1Row}>
                                        <Text style={styles.column1Label}>{localStorage.getItem("itrname")} :</Text>
                                        <Text style={styles.column1Value}>{knoData[0].cbhishi}</Text>
                                    </View>
                                ) : (
                                    ""
                                )}

                                {localStorage.getItem("itr4name") != "-" ? (
                                    <View style={styles.column1Row}>
                                        <Text style={styles.column1Label}>{localStorage.getItem("itr4name")} :</Text>
                                        <Text style={styles.column1Value}>{knoData[0].itrkapat1}</Text>
                                    </View>
                                ) : (
                                    ""
                                )}

                                {localStorage.getItem("itr5name") != "-" ? (
                                    <View style={styles.column1Row}>
                                        <Text style={styles.column1Label}>{localStorage.getItem("itr5name")} :</Text>
                                        <Text style={styles.column1Value}>{knoData[0].itrkapat2}</Text>
                                    </View>
                                ) : (
                                    ""
                                )}

                                {localStorage.getItem("itr6name") != "-" ? (
                                    <View style={styles.column1Row}>
                                        <Text style={styles.column1Label}>{localStorage.getItem("itr6name")} :</Text>
                                        <Text style={styles.column1Value}>{knoData[0].itrkapat3}</Text>
                                    </View>
                                ) : (
                                    ""
                                )}
                            </View>

                            {/* BILL (keep same styles, only replace hardcoded strings with billprint4 keys) */}
                            <View style={localStorage.getItem("design") === "1" ? styles.column3 : styles.column3noborder}>
                                <View style={styles.column1Row}>
                                    <Text style={styles.column1Label}>{t("billprint4.billBox.totalBill")}</Text>
                                    <Text style={styles.column1Value}>{sumOfFifthTable}</Text>
                                </View>

                                {parseFloat(knoData[0].vah !== null && !isNaN(knoData[0].vah) ? parseFloat(knoData[0].vah) : 0) > 0 ? (
                                    localStorage.getItem("billtype") === "oldbill" ? (
                                        <View style={styles.column1Row}>
                                            <Text style={styles.column1Label}>{t("billprint4.billBox.transportPlus")}</Text>
                                            <Text style={styles.column1Value}>{knoData[0].vah !== null && !isNaN(knoData[0].vah) ? parseFloat(knoData[0].vah).toFixed(2) : 0}</Text>
                                        </View>
                                    ) : (
                                        <View style={styles.column1Row}>
                                            <Text style={styles.column1Label}>{t("billprint4.billBox.transportPerLiterN")}</Text>
                                            <Text style={styles.column1Value}>
                                                {knoData[0].mhvah !== null && !isNaN(knoData[0].mhvah) ? parseFloat(parseFloat(knoData[0].mhvah) * parseFloat(totalOfTotalLiter)).toFixed(2) : 0}
                                            </Text>
                                        </View>
                                    )
                                ) : (
                                    ""
                                )}

                                {parseFloat(knoData[0].comm !== null && !isNaN(knoData[0].comm) ? parseFloat(knoData[0].comm) : 0) > 0 ? (
                                    localStorage.getItem("billtype") === "oldbill" ? (
                                        <View style={styles.column1Row}>
                                            <Text style={styles.column1Label}>{t("billprint4.billBox.commissionPlus")}</Text>
                                            <Text style={styles.column1Value}>{knoData[0].comm !== null && !isNaN(knoData[0].comm) ? parseFloat(knoData[0].comm).toFixed(2) : 0}</Text>
                                        </View>
                                    ) : (
                                        ""
                                    )
                                ) : (
                                    ""
                                )}

                                {localStorage.getItem("billtype") === "oldbill" ? (
                                    <View style={styles.column1Row}>
                                        <Text style={styles.column1Label}>{t("billprint4.billBox.totalDeduct")}</Text>
                                        <Text style={styles.column1Value}>{parseFloat(tkapat).toFixed(2)}</Text>
                                    </View>
                                ) : (
                                    <View style={styles.column1Row}>
                                        <Text style={styles.column1Label}>{t("billprint4.billBox.totalDeductN")}</Text>
                                        <Text style={styles.column1Value}>
                                            {parseFloat(
                                                parseFloat(knoData[0].mhliter * knoData[0].mhthev) +
                                                parseFloat(knoData[0].gayliter * knoData[0].gaythev) +
                                                parseFloat(kapat[kno] && !isNaN(kapat[kno].cuchal) ? kapat[kno].cuchal : 0) +
                                                parseFloat(kapat[kno] && !isNaN(kapat[kno].ckhadya) ? kapat[kno].ckhadya : 0) +
                                                parseFloat(knoData[0].ikapatliter !== null && !isNaN(knoData[0].ikapatliter) ? parseFloat(parseFloat(knoData[0].ikapatliter) * parseFloat(totalOfTotalLiter)).toFixed(2) : 0) +
                                                parseFloat(knoData[0].ikapatbill !== null && !isNaN(knoData[0].ikapatbill) ? parseFloat(knoData[0].ikapatbill).toFixed(2) : 0) +
                                                parseFloat(knoData[0].mhvah !== null && !isNaN(knoData[0].mhvah) ? parseFloat(parseFloat(knoData[0].mhvah) * parseFloat(totalOfTotalLiter)).toFixed(2) : 0)
                                            ).toFixed(2)}
                                        </Text>
                                    </View>
                                )}

                                {localStorage.getItem("billtype") === "oldbill" ? (
                                    <View style={styles.column1Rowgray}>
                                        <Text style={styles.column1Label}>{t("billprint4.billBox.netPayableOld")}</Text>
                                        <Text style={parseFloat(ada) >= 0 ? styles.tableCellgreen : styles.tableCellred}>
                                            {parseFloat(ada).toFixed(localStorage.getItem("round") === "on" ? 0 : 2)}
                                        </Text>
                                    </View>
                                ) : (
                                    <View style={styles.column1Rowgray}>
                                        <Text style={styles.column1Label}>{t("billprint4.billBox.netPayableN")}</Text>
                                        <Text style={parseFloat(ada) >= 0 ? styles.tableCellgreen : styles.tableCellred}>
                                            {parseFloat(
                                                parseFloat(sumOfFifthTable) -
                                                parseFloat(
                                                    parseFloat(knoData[0].mhliter * knoData[0].mhthev) +
                                                    parseFloat(knoData[0].gayliter * knoData[0].gaythev) +
                                                    parseFloat(kapat[kno] && !isNaN(kapat[kno].cuchal) ? kapat[kno].cuchal : 0) +
                                                    parseFloat(kapat[kno] && !isNaN(kapat[kno].ckhadya) ? kapat[kno].ckhadya : 0) +
                                                    parseFloat(knoData[0].ikapatliter !== null && !isNaN(knoData[0].ikapatliter) ? parseFloat(parseFloat(knoData[0].ikapatliter) * parseFloat(totalOfTotalLiter)).toFixed(2) : 0) +
                                                    parseFloat(knoData[0].ikapatbill !== null && !isNaN(knoData[0].ikapatbill) ? parseFloat(knoData[0].ikapatbill).toFixed(2) : 0) +
                                                    parseFloat(knoData[0].mhvah !== null && !isNaN(knoData[0].mhvah) ? parseFloat(parseFloat(knoData[0].mhvah) * parseFloat(totalOfTotalLiter)).toFixed(2) : 0)
                                                ).toFixed(2)
                                            ).toFixed(2)}
                                        </Text>
                                    </View>
                                )}
                            </View>

                        </View>


                        <View style={styles.simplecol}>
                            {localStorage.getItem("suchana") === "-" ? (
                                <Text style={styles.imgtext}>
                                    {t("billprint4.footer.msgDefault", { name: knoData[0].cname })}
                                </Text>
                            ) : (
                                <Text style={styles.imgtext}>{localStorage.getItem("suchana")}</Text>
                            )}
                        </View>

                        <View style={styles.line} />

                        <View style={styles.imagerow}>
                            <View style={styles.simplerow}>
                                {/* <Text style={styles.imgtext}>{t("billprint4.footer.poweredBy")}</Text> */}
                                {/* <Image style={styles.image} src={Logo} /> */}
                            </View>

                            <Text style={styles.imgtext}>
                                {t("billprint4.footer.contact", { phone: "800-788-9200" })}
                            </Text>
                        </View>

                        {index < Object.keys(data).length - 1 && <Text style={styles.pageBreak} />}

                    </View>)}
            </Page>

        </>
    );

}

export default Billprinta4;
